import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { schoolInsUpdSlice, selectSchoolInsUpd } from "../../../redux/school/schoolInsUpdSlice";
import { useAppDispatch } from "../../../app/hooks";
import { SchoolInfo } from "../../../redux/school/schoolSlice";
import { ImageProcessorStyle } from "../../../redux/common";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import React from "react";
import AvatarUploadDragAndDrop from "../../../features/base/image/AvatarUploadDragAndDrop";

export function SchoolInsUpdData() {
    const schoolInsUpd = useSelector(selectSchoolInsUpd);
    const dispatch = useAppDispatch();
    const [helpOpenReview, setHelpOpenReview] =  React.useState(false);

    const changed = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const school = {
            ...schoolInsUpd.school
        };
        school.name = event.target.value;
        dispatch(schoolInsUpdSlice.actions.set(school));
    };

    const handleAvatarChange = (img: string) => {
        const school = {
            ...schoolInsUpd.school,
            url: img
        };
        dispatch(schoolInsUpdSlice.actions.set(school));
    };

    return <>
        <Typography variant="h6" gutterBottom>
            Dados da escola
        </Typography>
        <Grid container spacing={3}>
            <Grid size={12}>
                <TextField required id="name" name="name" label="Nome"
                    fullWidth autoComplete="nome" variant="standard"
                    value={schoolInsUpd.school.name}
                    onChange={changed} />
            </Grid>
             <Grid size={12}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControl fullWidth>
                        <InputLabel id="image-processor-style-label">Status</InputLabel>
                        <Select
                            labelId="image-processor-style-label"
                            id="image-processor-style-select"
                            value={schoolInsUpd.school.imageProcessorStyle ?? ImageProcessorStyle.DIRECT}
                            label="Revisão de Imagem"
                            onChange={e => {
                                const school = {
                                    ...schoolInsUpd.school,
                                    imageProcessorStyle: Number(e.target.value)
                                } as SchoolInfo;
                                dispatch(schoolInsUpdSlice.actions.set(school));
                            }}
                        >
                            <MenuItem value={ImageProcessorStyle.DIRECT}>Sem revisão</MenuItem>
                            <MenuItem value={ImageProcessorStyle.REVIEW_REQUIRED}>Revisão obrigatória</MenuItem>
                        </Select>
                    </FormControl>
                    <Button sx={{ ml: 1, minWidth: 0 }} onClick={() => setHelpOpenReview(true)}><HelpOutlineIcon /></Button>
                </Box>
                <Dialog open={helpOpenReview} onClose={() => setHelpOpenReview(false)}>
                    <DialogTitle>Revisão de imagem</DialogTitle>
                    <DialogContent>
                        <Typography variant="h6">
                            Sem revisão
                        </Typography>
                        <Typography variant="body1">
                            As imagens enviadas para a sala de aula serão enviadas para os pais assim que possível.
                        </Typography>
                        <br/>
                        <Typography variant="h6">
                            Revisão Obrigatória
                        </Typography>
                        <Typography variant="body1">
                            As imagens enviadas para a sala de aula precisarão ser revisadas por alguém autorizado antes de serem enviadas para os pais.<br/>
                            Se concedida permissão, o próprio usuário que enviou a foto poderá realizar a revisão.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setHelpOpenReview(false)}>Fechar</Button>
                    </DialogActions>
                </Dialog>
            </Grid>
            <Grid size={12}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Avatar
                </Typography>
                <AvatarUploadDragAndDrop
                    value={schoolInsUpd.school.url || ""}
                    onChange={handleAvatarChange}
                    alt={schoolInsUpd.school.name}
                />
            </Grid>
        </Grid>
    </>;
}